module.exports = __webpack_public_path__ + "8b3dec079def37316751821dde525d8c.jpg";